<template>
  <div class="subscChangedMind">
    <h2 class="subscChangedMind__title">サブスクリプションを<br>再開しますか？</h2>
    <form-area
      :action="action"
      :method="method"
      :token="token"
    >
      <submit-button type="submit" text="解約取り消しの完了" />
    </form-area>
  </div>
</template>

<script>
import SubmitButton from '../partials/SubmitButton'

export default {
  name: "SubscChangedMind",
  components: {
    SubmitButton
  },
  props: {
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'POST'
    },
    token: {
      type: String,
      default: ''
    },
  },
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.subscChangedMind {
  padding: 35px 4px 30px;
  color: $col_base_black;
  max-width: 580px;
  margin: auto;

  &__title{
    margin-top: 0;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
  }
}
.submit-button {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SubscChangedMind.vue